import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { deleteUrl: String };

  open() {
    document.dispatchEvent(
      new CustomEvent('moodboard--templates--delete-confirmation-modal:open', {
        detail: { deleteUrl: this.deleteUrlValue },
      })
    );
  }
}
